<h1 mat-dialog-title>{{tituloDialog}}</h1>
<form [formGroup]="form">
  <div mat-dialog-content class="qualificates-theme">

    <div fxLayout="row" class="flexwrap">

      <div fxFlex="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.type.label' | translate }}</mat-label>
          <mat-select required formControlName="idType" [(ngModel)]="data.equipment.idType">
            @for (item of equipmentTypes; track item) {
              <mat-option [value]="item.id">
                {{ 'equipmentType.' + item.translation | translate }}
              </mat-option>
            }
          </mat-select>
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.type.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.equipment.label' | translate }}</mat-label>
          <input matInput
            formControlName="equipment" [(ngModel)]="data.equipment.equipment" required>
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.equipment.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.maker.label' | translate }}</mat-label>
          <input matInput
            formControlName="maker" [(ngModel)]="data.equipment.maker">
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.maker.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.model.label' | translate }}</mat-label>
          <input matInput
            formControlName="model" [(ngModel)]="data.equipment.model">
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.model.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.serialNum.label' | translate }}</mat-label>
          <input matInput
            formControlName="serialNum" [(ngModel)]="data.equipment.serialNumber">
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.serialNum.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.internalId.label' | translate }}</mat-label>
          <input matInput
            formControlName="internalId" [(ngModel)]="data.equipment.internalId">
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.internalId.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.location.label' | translate }}</mat-label>
          <input matInput
            formControlName="location" [(ngModel)]="data.equipment.location" required>
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.location.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      @if (showIsCentrifuge()) {
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.rotorModel.label' | translate }}</mat-label>
            <input matInput
              formControlName="rotorModel" [(ngModel)]="data.equipment.rotorModel">
            <mat-error>
              {{ 'protocolEdit.dialog.equipment.rotorModel.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      }
      @if (showIsCentrifuge()) {
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.rotorSerial.label' | translate }}</mat-label>
            <input matInput
              formControlName="rotorSerial" [(ngModel)]="data.equipment.rotorSerial">
            <mat-error>
              {{ 'protocolEdit.dialog.equipment.rotorSerial.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      }
      @if (showEquipmentAllowed()) {
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{'protocolEdit.dialog.equipment.mappingType.label' | translate }}</mat-label>
            <mat-select [(ngModel)]="data.equipment.mappingType" name="mappingType" formControlName="mappingType" >
              <mat-option>--</mat-option>
              @for (item of mappingTypes; track item) {
                <mat-option [value]="item.value">
                  {{ 'mappingType.' + item.value | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>

  </div>
  <div mat-dialog-actions>
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>